import styled from 'styled-components';
import { ANIMATION_DURATION, getSpacingToken, getToken, IconButton } from '@optimus-web/core';

const TOGGLE_WIDTH = '32px';

interface ContainerProps {
    opened: boolean;
    children: React.ReactNode;
}

export const Container = styled.div<ContainerProps>`
    position: fixed;
    box-sizing: border-box;
    background-color: ${getToken('backgroundStaticFlat')};
    right: 0;
    top: 50%;
    padding: ${getSpacingToken('200')}px;
    transition: transform ${ANIMATION_DURATION.default}ms;
    ${(props) => `transform: translateY(-50%) translateX(${props.opened ? '0' : '100%'});`}
    width: 232px;
    box-shadow: ${getToken('shadow300')};
    border-radius: ${getToken('borderRadius100')}px ${getToken('borderRadius0')} ${getToken('borderRadius0')}
        ${getToken('borderRadius100')}px;
`;

export const ToggleArrow = styled(IconButton)`
    position: absolute;
    left: -${TOGGLE_WIDTH};
    top: 64px;
    width: ${TOGGLE_WIDTH};
    height: 54px;
    border-bottom-right-radius: ${getToken('borderRadius0')};
    border-top-right-radius: ${getToken('borderRadius0')};
`;
